
import { Form, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import Chip from '@mui/material/Chip';
import DangerousIcon from '@mui/icons-material/Dangerous';
import { getFullFaceDescription } from "../../faceUtil";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { DEFAULT_WEBCAM_RESOLUTION, inputSize, webcamResolutionType } from "../../globalData";
import { drawFaceRect } from "../../utils/drawFaceRect";
import { MatButton } from "../../components/elements";

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import useWindowDimensions from "../../hooks/useWindowDimensions";

const { Option } = Select;
export const UploadFromWebcam = ({
   addFacePhotoCallback,
   isSubmitting,
   closeWebCam
   // loading,
}) => {
     const { height, width } = useWindowDimensions();
   const [isScanning, setIsScanning] = useState(false);

   const [camWidth, setCamWidth] = useState(width <= 640 ? width : 640);
   const [camHeight, setCamHeight] = useState(width <= 640 ? width*0.7 : 480);

   const [inputDevices, setInputDevices] = useState([]);
   const [selectedWebcam, setSelectedWebcam] = useState();
   const [fullDesc, setFullDesc] = useState(null);
   const [faceDescriptor, setFaceDescriptor] = useState([]);
   const [previewImage, setPreviewImage] = useState("");
   const [waitText, setWaitText] = useState("");
   const webcamRef = useRef();
   const canvasRef = useRef();





   const handleSelectWebcam = (value) => {
      setSelectedWebcam(value);
   };
   const handleWebcamResolution = (value) => {
      webcamResolutionType.map((type) => {
         if (value === type.label) {
            setCamWidth(type.width);
            setCamHeight(type.height);
         }
      });
   };

 

   useEffect(() => {
      setIsScanning(true);
   }, []);


   useEffect(() => {
      navigator.mediaDevices.enumerateDevices().then(async (devices) => {
         let inputDevice = await devices.filter((device) => device.kind === "videoinput");
         if (inputDevice?.length > 0) {
            setInputDevices({ ...inputDevices, inputDevice });
            setSelectedWebcam(inputDevice[0].deviceId);
         }
      });
   }, []);


   useEffect(() => {
      function capture() {
         if (
            typeof webcamRef.current !== "undefined" &&
            webcamRef.current !== null &&
            webcamRef.current.video.readyState === 4
         ) {

            setPreviewImage(webcamRef.current.getScreenshot());

            // const videoWidth = webcamRef.current.video.videoWidth;
            // const videoHeight = webcamRef.current.video.videoHeight;

            // Set canvas height and width
            // canvasRef.current.width = videoWidth;
            // canvasRef.current.height = videoHeight;


            // Set canvas height and width
            canvasRef.current.width = webcamRef.current.video.offsetWidth;
            canvasRef.current.height = webcamRef.current.video.offsetHeight;

            // 4. TODO - Make Detections
            // e.g. const obj = await net.detect(video);

            // Draw mesh
            getFullFaceDescription(webcamRef.current.getScreenshot(), inputSize)
               .then((data) => {
                  setFullDesc(data);
                  setFaceDescriptor(data[0]?.descriptor);
                  setWaitText("");
                  setIsScanning(false);

               })
               .catch((err) => {
                  setWaitText(
                     "Preparing face matcher and device setup, please wait..."
                  );
               });
            const ctx = canvasRef.current.getContext("2d");

            drawFaceRect(fullDesc, ctx);
         }
      }

      let interval = setInterval(() => {
         capture();
      }, 700);

      return () => clearInterval(interval);
   });


   const handleSubmit = () => {
      addFacePhotoCallback({ photoData: previewImage, faceDescriptor: faceDescriptor.toString() });
   };




   return (
      <>
         <div className="cam-upload-box">
            {/* <Form>
               <div className="cam-options">
                  <Form.Item label="Webcam">
                     <Select
                        defaultValue="Select Webcam"
                        style={{ width: 200, marginBottom: '8px' }}
                        onChange={handleSelectWebcam}
                        value={selectedWebcam}
                     >
                        {inputDevices?.inputDevice?.map((device) => (
                           <Option key={device.deviceId} value={device.deviceId}>
                              {device.label}
                           </Option>
                        ))}
                     </Select>
                  </Form.Item>
                  <Form.Item label="Webcam Size">
                     <Select
                        defaultValue={DEFAULT_WEBCAM_RESOLUTION.label}
                        style={{ width: 200, marginBottom: '8px' }}
                        onChange={handleWebcamResolution}
                     >
                        {webcamResolutionType.map((type) => (
                           <Option key={type.label} value={type.label}>
                              {type.label}
                           </Option>
                        ))}
                     </Select>
                  </Form.Item>
               </div>
            </Form> */}
            <p style={{ fontSize: "18px" }}>{waitText}</p>
            <div
               style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // marginTop: "-12px"
               }}
            >

               {/* <IconButton className="close-icon-btn" onClick={closeWebCam}>
                  <CloseIcon />
               </IconButton> */}

               <Webcam
                  muted={true}
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{
                     deviceId: '',
                  }}
                  mirrored
               />
               <canvas
                  ref={canvasRef}
                  style={{
                     position: "absolute",
                     textAlign: "center",
                     zIndex: 8,
                  }}
              
               />
            </div>


            <div className="face-stats">
               <p>Face detected : {fullDesc ? fullDesc.length : 0}{" "}</p>
               {fullDesc && fullDesc.length > 1 && (
                  <Chip color="error" icon={<DangerousIcon />} label="Only 1 person face allowed" variant="outlined" />
               )}
            </div>
            {isScanning ? (
               <div className=" text-center">
                  <h6>Please wait...</h6>
               </div>
            ) : null}

            {(previewImage && fullDesc?.length === 1) && (
               <div className="cam-preview-img" >
                  <div className="img--preview-box text-center">
                     <img src={previewImage} alt="Capture" />
                  </div>

                  <div className="btn-submit">
                     <MatButton
                        onClick={handleSubmit}
                        disableElevation
                        className="upload-btn"
                        btnText={isSubmitting ? "Uploading" : "Upload"}
                        disabled={isSubmitting || (fullDesc && fullDesc?.length !== 1) || (faceDescriptor && faceDescriptor.length !== 128)}
                        isLoading={isSubmitting}
                        endIcon={isSubmitting ? null : <CloudUploadIcon />}
                     />
                  </div>
               </div>
            )}
         </div>
      </>
   );
};